// mixins/globalMemoryMixin.js
import { useGlobalMemoryManagement } from '@/composables/useGlobalMemoryManagement';

export const GlobalMemoryMixin = {
  setup() {
    // This will automatically run for every component
    useGlobalMemoryManagement();
  }
};